import { ArrowLeftIcon } from '@heroicons/react/24/solid';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import SentMailsHistory from '../../components/Setup/MailConfig/SentMailsHistory';
import { ROUTES } from '../../utils/routes';

function SetupSentMailsView() {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(ROUTES.SETUP_MAIL_CONFIG);
  };

  return (
    <div className="mx-auto">
      <div className="mb-6">
        <button
          onClick={handleGoBack}
          className="flex items-center rounded-lg border border-gray-300 bg-white px-4 py-2 text-gray-700 transition-colors hover:bg-gray-50"
        >
          <ArrowLeftIcon className="mr-2 h-5 w-5" />
          Retour à la configuration mail
        </button>
      </div>

      <div className="mb-8 rounded-lg bg-white p-8 shadow-md">
        <h1 className="mb-4 text-3xl font-bold text-gray-900">
          Historique des emails envoyés
        </h1>
        <p className="text-gray-700">
          Cette page vous permet de retrouver tous les emails envoyés pour votre entreprise depuis la plateforme.
          Vous pouvez filtrer par expéditeur, rechercher un destinataire, un objet ou un contenu de message.
        </p>
      </div>

      <SentMailsHistory />
    </div>
  );
}

export default SetupSentMailsView;
